import styled from "styled-components";

export const SignUpContainer = styled.div`
  margin: auto;
  width: auto;
  max-width: 550px;
  padding: 4%;
`;
export const WelcomeText = styled.h2`
  font-size: 20px;
  padding: 10px;
  text-align: center;
  color: black;
  text-decoration: bold;
`;

export const SpanText = styled.h2`
  text-align: center;
  color: black;
  text-decoration: solid;
`;

export const FormContainer = styled.form`
  justify-content: center;
  align-items: center;
  width: auto;
  height: auto;
  border-radius: 8px;
  padding: 10px 10px;
  box-shadow: 0 10px 25px rgba(92, 99, 105, 0.2);
  padding: 15px;
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(8.5px);
  -webkit-backdrop-filter: blur(8.5px);
  border-radius: 10px;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.4rem;
  @media only screen and (max-width: 320px) {
    hr {
      margin-bottom: 0.3rem;
    }
    h2 {
      background-color: black;
    }
  }
  @media only screen and (min-width: 50%) {
    width: 50%;
    height: 50%;
  }
  @media only screen and (min-width: 50%) {
    width: 50%;
    height: 50%;
  }
`;

export const ButtonContainer = styled.div`
  margin: 1rem 0 2rem 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HorizontalRule = styled.hr`
  width: 100%;
  height: 0.3rem;
  border-radius: 0.8rem;
  border: none;
  background: linear-gradient(to right, #14163c 0%, #03217b 79%);
  background-color: #ebd0d0;
  margin: 1.5rem 0 1rem 0;
  backdrop-filter: blur(25px);
`;

export const SignUpPage = styled.div`
  padding: 15px 10px;
  text-align: center;
  p {
    color: black;
    padding-bottom: 15px;
  }
`;
